export const TableNoRecordFound = () => {
  return <span className="textColorPrimary">No record found</span>;
};

export const TableLocaleCustom = {
  emptyText: <TableNoRecordFound />,
};
